import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { Label } from "@/components/ui/Label";
import { cn } from "@/lib/utils";
import { useLanguage } from "@/context/LanguageContext";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

interface PasswordFieldProps {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
  inputClassName?: string;
}

export function PasswordField({
  id,
  name,
  label,
  value,
  onChange,
  autoComplete,
  inputClassName,
}: PasswordFieldProps) {
  const [show, setShow] = useState(false);
  const { language } = useLanguage();
  const visibilityLabel = show
    ? language === "cs"
      ? "Skrýt heslo"
      : "Hide password"
    : language === "cs"
      ? "Zobrazit heslo"
      : "Show password";

  return (
    <div className="app-form-row">
      <Label htmlFor={id} className="text-right">
        {label}
      </Label>
      <Input
        id={id}
        name={name}
        placeholder="••••••••"
        className={cn("col-span-3", inputClassName)}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        type={show ? "text" : "password"}
        autoComplete={autoComplete}
        required
      />
      <Button
        type="button"
        variant="icon"
        size="icon"
        onClick={() => setShow(!show)}
        className="absolute right-7 top-0.5 z-50 h-8 w-8 text-softiq-primary dark:text-softiq-secondary-shade-200 "
        aria-label={visibilityLabel}
      >
        {show ? (
          <EyeSlashIcon className="size-5" aria-hidden="true" />
        ) : (
          <EyeIcon className="size-5" aria-hidden="true" />
        )}
      </Button>
    </div>
  );
}
